import React from "react";
import styled from "styled-components";

/*
 * Veliki preview slike koji prati kursor (hover na thumbnail u admin
 * tabelama). Pozicija se klampuje po OBE ose da preview uvek stane u
 * viewport: po X ide desno od kursora, a ako ne staje prebacuje se levo;
 * po Y se centar pomera ka sredini ekrana. Na malim ekranima se i sama
 * veličina smanjuje da bi stala.
 */

const PREVIEW_MARGIN = 12;
const CURSOR_OFFSET = 30;

const Wrap = styled.div`
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  border: 2px solid var(--brand);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.65);
  transform: translateY(-50%);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

export default function CursorImagePreview({ preview, size = 360 }) {
  if (!preview) return null;

  const effectiveSize = Math.max(
    120,
    Math.min(
      size,
      window.innerWidth - PREVIEW_MARGIN * 2,
      window.innerHeight - PREVIEW_MARGIN * 2,
    ),
  );
  const half = effectiveSize / 2;

  // Y: centar previewa (translateY(-50%)) ograničen da gornja/donja ivica
  // ne izađu iz ekrana
  const top = Math.min(
    Math.max(preview.y, half + PREVIEW_MARGIN),
    window.innerHeight - half - PREVIEW_MARGIN,
  );

  // X: desno od kursora; ako ne staje, levo od kursora; krajnji fallback
  // je pin uz levu ivicu
  let left = preview.x + CURSOR_OFFSET;
  if (left + effectiveSize > window.innerWidth - PREVIEW_MARGIN) {
    left = preview.x - CURSOR_OFFSET - effectiveSize;
  }
  if (left < PREVIEW_MARGIN) {
    left = PREVIEW_MARGIN;
  }

  return (
    <Wrap style={{ top, left, width: effectiveSize, height: effectiveSize }}>
      <img src={preview.src} alt="" />
    </Wrap>
  );
}
